import gql from 'graphql-tag';

export const FEES_EXPENSES = gql`
    query FeesExpenses($ticker: String!) {
        mutualFund(ticker: $ticker) {
            activeMoneyMarketFundMessages {
                message
            }
            Strategy: strategyText
            grossExpenseRatio
            netExpenseRatio
            expenseRatioWaiverType
            expenseRatioWaiverExpirationDate
            transactionFee
            fee121b
        }
    }
`;

export const ETF_FEES_EXPENSES = gql`
    query ETFFeesExpenses($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            grossExpenseRatio
            netExpenseRatio
        }
    }
`;
